import React, { useContext, useEffect } from "react";

import { Grid, Grow } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Select from "../../../../components/basics/SelectErp";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import useCalculosTributacao from "../controllers/RulesEmissaoCalculosTributacao";
import { AplicaveisBc } from "./RulesEmissaoTributacao";

import { Margin } from "../styles/Emissao";
import { EmissaoContext } from "../contexts/EmissaoContext";

const TabEmissaoCofins = ({ ...props }) => {
  const {
    productCofinsSituation,
    setProductCofinsSituation,
    productCofinsPercentAliquot,
    setProductCofinsPercentAliquot,
    productCofinsAliquot,
    setProductCofinsAliquot,
    productCofinsBcValue,
    setProductCofinsBcValue,
    productCofinsValue,
    setProductCofinsValue,
    productCofinsListSituation,
    productError,
    productCheckCofinsFreight,
    setProductCheckCofinsFreight,
    productCheckCofinsSafe,
    setProductCheckCofinsSafe,
    productCheckCofinsOthers,
    setProductCheckCofinsOthers,
    productCheckCofinsDiscount,
    setProductCheckCofinsDiscount,
    productCheckCofinsDescIcms,
    setProductCheckCofinsDescIcms,
  } = useContext(ParametrosProdutoContext);

  const { visualizationOnly, nfeMontageSubtype } = useContext(EmissaoContext);

  const { handleCalcCofins, handleCofinsSituation } = useCalculosTributacao();

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCofinsSituation();
  }, [handleCofinsSituation, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcCofins();
  }, [handleCalcCofins, nfeMontageSubtype]);

  return (
    <Grid container spacing={2}>
      {AplicaveisBc({
        frete: productCheckCofinsFreight,
        setFrete: setProductCheckCofinsFreight,
        seguro: productCheckCofinsSafe,
        setSeguro: setProductCheckCofinsSafe,
        desconto: productCheckCofinsDiscount,
        setDesconto: setProductCheckCofinsDiscount,
        outras: productCheckCofinsOthers,
        setOutras: setProductCheckCofinsOthers,
        descIcms: productCheckCofinsDescIcms,
        setDescIcms: setProductCheckCofinsDescIcms,
      })}
      <Grow in={true}>
        <Grid item sm={12}>
          <Card line="left">
            <Margin top="10">
              <Grid container spacing={2}>
                <Grid item sm={12}>
                  <Select
                    variant="filled"
                    value={productCofinsSituation}
                    setValue={setProductCofinsSituation}
                    descriptionField="label"
                    label="Situação Tributária COFINS"
                    optionsList={productCofinsListSituation}
                    error={productError.productCofinsSituation ? true : false}
                    helperText={productError.productCofinsSituation || ""}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productCofinsBcValue}
                    setValue={setProductCofinsBcValue}
                    size="small"
                    label="BC do COFINS R$"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productCofinsPercentAliquot}
                    setValue={setProductCofinsPercentAliquot}
                    size="small"
                    label="Aliquota do COFINS %"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productCofinsAliquot}
                    setValue={setProductCofinsAliquot}
                    size="small"
                    label="Aliquota do COFINS R$"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productCofinsValue}
                    setValue={setProductCofinsValue}
                    size="small"
                    label="Valor do COFINS R$"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
              </Grid>
            </Margin>
          </Card>
        </Grid>
      </Grow>
    </Grid>
  );
};

export default TabEmissaoCofins;
